import { adminServerInstance, driverServerInstance, deliveryServerInstance } from "../axios/instances";
import { 
    GET_INDIVIDUAL,
    GET_INDIVIDUAL_SUCCESS,
    GET_INDIVIDUAL_FAIL,
    GET_PROFILE,
    GET_PROFILE_SUCCESS,
    GET_PROFILE_FAIL,
    GET_VEHICLE_TYPE,
    GET_VEHICLE_TYPE_SUCCESS,
    GET_VEHICLE_TYPE_FAIL,
    GET_DELIVERY_AREAS,
    GET_DELIVERY_AREAS_SUCCESS,
    GET_DELIVERY_AREAS_FAIL,
    GET_INDIVIDUAL_DOCUMENT,
    GET_INDIVIDUAL_DOCUMENT_SUCCESS,
    GET_INDIVIDUAL_DOCUMENT_FAIL,
    GET_DRIVER_BY_ID,
    GET_DRIVER_BY_ID_SUCCESS,
    GET_DRIVER_BY_ID_FAIL,
    EDIT_PROFILE,
    EDIT_PROFILE_SUCCESS,
    EDIT_PROFILE_FAIL,
    GET_CITY_LIST,
    GET_CITY_LIST_SUCCESS,
    GET_CITY_LIST_FAIL,
    GET_REVIEW_COUNT,
    GET_REVIEW_COUNT_SUCCESS,
    GET_REVIEW_COUNT_FAIL,
    PUT_REVIEW_RESULT,
    PUT_REVIEW_RESULT_SUCCESS,
    PUT_REVIEW_RESULT_FAIL,
    GET_COUNTRY_LIST,
    GET_COUNTRY_LIST_SUCCESS,
    GET_COUNTRY_LIST_FAIL,
    GET_PROVINCE_LIST,
    GET_PROVINCE_LIST_SUCCESS,
    GET_PROVINCE_LIST_FAIL,
    CREATE_NEW_DRIVER,
    CREATE_NEW_DRIVER_SUCCESS,
    CREATE_NEW_DRIVER_FAIL,
    EDIT_PROFILE_ADDITIONAL,
    EDIT_PROFILE_ADDITIONAL_SUCCESS,
    EDIT_PROFILE_ADDITIONAL_FAIL,
    EDIT_SALARY_TYPE,
    EDIT_SALARY_TYPE_SUCCESS,
    EDIT_SALARY_TYPE_FAIL,
    GET_DRIVER_BASIC,
    GET_DRIVER_BASIC_SUCCESS,
    GET_DRIVER_BASIC_FAIL,
    EDIT_DRIVER_BASIC,
    EDIT_DRIVER_BASIC_SUCCESS,
    EDIT_DRIVER_BASIC_FAIL,
    GET_ACCOUNT_DOCUMENT,
    GET_ACCOUNT_DOCUMENT_SUCCESS,
    GET_ACCOUNT_DOCUMENT_FAIL,
    GET_DRIVER_ADDITIONAL,
    GET_DRIVER_ADDITIONAL_SUCCESS,
    GET_DRIVER_ADDITIONAL_FAIL,
    GET_SALARY_TYPE_ADDITIONAL,
    GET_SALARY_TYPE_ADDITIONAL_SUCCESS,
    GET_SALARY_TYPE_ADDITIONAL_FAIL,
    DELETE_ACCOUNT_DOCUMENT,
    DELETE_ACCOUNT_DOCUMENT_SUCCESS,
    DELETE_ACCOUNT_DOCUMENT_FAIL,
    POST_ACCOUNT_DOCUMENT,
    POST_ACCOUNT_DOCUMENT_SUCCESS,
    POST_ACCOUNT_DOCUMENT_FAIL,
    SWITCH_SORTING_SCAN,
    SWITCH_SORTING_SCAN_SUCCESS,
    SWITCH_SORTING_SCAN_FAIL,
    GET_PROVINCE_COUNTRY_BY_WAREHOUSE,
    GET_PROVINCE_COUNTRY_BY_WAREHOUSE_SUCCESS,
    GET_PROVINCE_COUNTRY_BY_WAREHOUSE_FAIL,
    GET_DELIVERY_AREAS_BY_WAREHOUSE,
    GET_DELIVERY_AREAS_BY_WAREHOUSE_SUCCESS,
    GET_DELIVERY_AREAS_BY_WAREHOUSE_FAIL,
    RESET_DRIVER_PASSWORD,
    RESET_DRIVER_PASSWORD_SUCCESS,
    RESET_DRIVER_PASSWORD_FAIL,
    SET_DOUBLE_CHECK,
    SET_DOUBLE_CHECK_SUCCESS,
    SET_DOUBLE_CHECK_FAIL,
    DELETE_DOUBLE_CHECK,
    DELETE_DOUBLE_CHECK_SUCCESS,
    DELETE_DOUBLE_CHECK_FAIL,
    GET_DOUBLE_CHECK,
    GET_DOUBLE_CHECK_SUCCESS,
    GET_DOUBLE_CHECK_FAIL,
    GET_FUEL_TYPE,
    GET_FUEL_TYPE_SUCCESS,
    GET_FUEL_TYPE_FAIL
} from './types';

export function getDoubleCheck(driverId) {
    return function (dispatch) {
        dispatch({ type: GET_DOUBLE_CHECK })
        return deliveryServerInstance.get(`/masterdata/ext/feature-flags/${driverId}-double-check`)
            .then(({ data }) => {
                dispatch({
                    type: GET_DOUBLE_CHECK_SUCCESS,
                    payload: data.biz_data
                })
                return Promise.resolve(data.biz_data);
            }).catch(error => {
                dispatch({
                    type: GET_DOUBLE_CHECK_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function deleteDoubleCheck(driverId, operator) {
    return function (dispatch) {
        dispatch({ type: DELETE_DOUBLE_CHECK })
        return deliveryServerInstance.delete(`/tools/feature-flags/${driverId}`, {
            data: {
                'feature_flag': "double-check",
                'operator': operator
            }
        })
            .then(({ data }) => {
                dispatch({
                    type: DELETE_DOUBLE_CHECK_SUCCESS,
                    payload: data.biz_data
                })
                return Promise.resolve(data.biz_data);
            }).catch(error => {
                dispatch({
                    type: DELETE_DOUBLE_CHECK_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function addDoubleCheck(driverId, operator) {
    return function (dispatch) {
        dispatch({ type: SET_DOUBLE_CHECK })
        return deliveryServerInstance.put(`/tools/feature-flags/${driverId}`, {
            'feature_flag': "double-check",
            'operator': operator
        })
            .then(({ data }) => {
                dispatch({
                    type: SET_DOUBLE_CHECK_SUCCESS,
                    payload: data.biz_data
                })
                return Promise.resolve(data.biz_data);
            }).catch(error => {
                dispatch({
                    type: SET_DOUBLE_CHECK_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getProvinceCountryByWarehouse(warehouse) {
    return function(dispatch) {
        dispatch({type: GET_PROVINCE_COUNTRY_BY_WAREHOUSE})
        return driverServerInstance.get(`/masterdata/regions?warehouse=${warehouse}`)
        .then(({data}) => {
            dispatch({
                type: GET_PROVINCE_COUNTRY_BY_WAREHOUSE_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
              type: GET_PROVINCE_COUNTRY_BY_WAREHOUSE_FAIL,
              payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getDeliveryAreasByWarehouse(warehouse) {
    return function(dispatch) {
        dispatch({type: GET_DELIVERY_AREAS_BY_WAREHOUSE})
        return driverServerInstance.get(`/masterdata/deliveryareas?warehouse=${warehouse}`)
        .then(({data}) => {
            dispatch({
                type: GET_DELIVERY_AREAS_BY_WAREHOUSE_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_DELIVERY_AREAS_BY_WAREHOUSE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function switchSortingScan(id, bossflg) {
    return function(dispatch) {
        dispatch({type: SWITCH_SORTING_SCAN})
        return driverServerInstance.put(`/account/sorting_scan_switch/individual/${id}`, {
            bossflg: bossflg
        })
        .then(({data}) => {
            dispatch({
                type: SWITCH_SORTING_SCAN_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: SWITCH_SORTING_SCAN_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function deleteAccountDoc(id, type) {
    return function(dispatch) {
        dispatch({type: DELETE_ACCOUNT_DOCUMENT})
        return driverServerInstance.delete(`/account/documents/individual/${id}/${type}`)
        .then(({data}) => {
            dispatch({
                type: DELETE_ACCOUNT_DOCUMENT_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: DELETE_ACCOUNT_DOCUMENT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getSalaryType(id) {
    return function(dispatch) {
        dispatch({type: GET_SALARY_TYPE_ADDITIONAL})
        return driverServerInstance.get(`/account/salary_type/individual/${id}`)
        .then(({data}) => {
            dispatch({
                type: GET_SALARY_TYPE_ADDITIONAL_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_SALARY_TYPE_ADDITIONAL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getDriverAdditional(id) {
    return function(dispatch) {
        dispatch({type: GET_DRIVER_ADDITIONAL})
        return driverServerInstance.get(`/account/additional_info/individual/${id}`)
        .then(({data}) => {
            dispatch({
                type: GET_DRIVER_ADDITIONAL_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_DRIVER_ADDITIONAL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getAccountDocument(id) {
    return function(dispatch) {
        dispatch({type: GET_ACCOUNT_DOCUMENT})
        return driverServerInstance.get(`/account/documents/individual/${id}`)
        .then(({data}) => {
            dispatch({
                type: GET_ACCOUNT_DOCUMENT_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_ACCOUNT_DOCUMENT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function postAccountDocument(id, formData) {
    return function(dispatch) {
        dispatch({type: POST_ACCOUNT_DOCUMENT})
        return driverServerInstance.post(`/account/documents/individual/${id}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        )
        .then(({data}) => {
            dispatch({
                type: POST_ACCOUNT_DOCUMENT_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: POST_ACCOUNT_DOCUMENT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function editDriverBasic(id, params) {
    return function(dispatch) {
        dispatch({type: EDIT_DRIVER_BASIC})
        return deliveryServerInstance.put(`/account/profile/individual/${id}`, {...params})
        .then(({data}) => {
            dispatch({
                type: EDIT_DRIVER_BASIC_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: EDIT_DRIVER_BASIC_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getDriverBasic(id) {
    return function(dispatch) {
        dispatch({type: GET_DRIVER_BASIC})
        return deliveryServerInstance.get(`/account/profile/individual/${id}`)
        .then(({data}) => {
            dispatch({
                type: GET_DRIVER_BASIC_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_DRIVER_BASIC_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function editSalaryType(id, type) {
    return function(dispatch) {
        dispatch({type: EDIT_SALARY_TYPE})
        return driverServerInstance.put(`/account/salary_type/individual/${id}`, {
            salary_types: type
        })
        .then(({data}) => {
            dispatch({
                type: EDIT_SALARY_TYPE_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: EDIT_SALARY_TYPE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function editProfileAdditional(id, params) {
    return function(dispatch) {
        dispatch({type: EDIT_PROFILE_ADDITIONAL})
        return driverServerInstance.put(`/account/additional_info/individual/${id}`, {...params})
        .then(({data}) => {
            dispatch({
                type: EDIT_PROFILE_ADDITIONAL_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: EDIT_PROFILE_ADDITIONAL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function createNewDriver(phone, password) {
    return function(dispatch) {
        dispatch({type: CREATE_NEW_DRIVER})
        return driverServerInstance.post(`/account/individual`, {
            phone: phone,
            password: password
        })
        .then(({data}) => {
            dispatch({
                type: CREATE_NEW_DRIVER_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: CREATE_NEW_DRIVER_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getProvinceList(country) {
    return function(dispatch) {
        dispatch({type: GET_PROVINCE_LIST})
        return driverServerInstance.get(`/masterdata/provinces/${country}`)
        .then(({data}) => {
            dispatch({
                type: GET_PROVINCE_LIST_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_PROVINCE_LIST_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getCountryList() {
    return function(dispatch) {
        dispatch({type: GET_COUNTRY_LIST})
        return driverServerInstance.get(`/masterdata/countries`)
        .then(({data}) => {
            dispatch({
                type: GET_COUNTRY_LIST_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_COUNTRY_LIST_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getIndividual(period = 30, page, size = 10, driverId, phone, status, warehouse) {
    let url = ``;
    if(driverId) {
        if(status) {
            url = `/application/individual?criteria=tobereviewed&period=${period}&page=${page}&size=${size}&account_id=${driverId}&status=${status}&warehouse=${warehouse}`
        } else {
            url = `/application/individual?criteria=tobereviewed&period=${period}&page=${page}&size=${size}&account_id=${driverId}&warehouse=${warehouse}`
        }
    } else if(phone) {
        if(status) {
            url = `/application/individual?criteria=tobereviewed&period=${period}&page=${page}&size=${size}&phone=${phone}&status=${status}&warehouse=${warehouse}`
        } else {
            url = `/application/individual?criteria=tobereviewed&period=${period}&page=${page}&size=${size}&phone=${phone}&warehouse=${warehouse}`
        }
    } else {
        if(status) {
            url = `/application/individual?criteria=tobereviewed&period=${period}&page=${page}&size=${size}&status=${status}&warehouse=${warehouse}`
        } else {
            url = `/application/individual?criteria=tobereviewed&period=${period}&page=${page}&size=${size}&warehouse=${warehouse}`
        }
    }
    return function(dispatch) {
        dispatch({type: GET_INDIVIDUAL})
        return driverServerInstance.get(url)
        .then(({data}) => {
            dispatch({
                type: GET_INDIVIDUAL_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_INDIVIDUAL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getProfile(id) {
    return function(dispatch) {
        dispatch({type: GET_PROFILE})
        return deliveryServerInstance.get(`/application/profile/individual/${id}`)
        .then(({data}) => {
            dispatch({
                type: GET_PROFILE_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_PROFILE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getFuelTypes() {
    return function (dispatch) {
        dispatch({ type: GET_FUEL_TYPE })
        return deliveryServerInstance.get(`/masterdata/vehicle/fuel/types`)
            .then(({ data }) => {
                dispatch({
                    type: GET_FUEL_TYPE_SUCCESS,
                    payload: data.biz_data
                })
                return Promise.resolve(data.biz_data);
            }).catch(error => {
                dispatch({
                    type: GET_FUEL_TYPE_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function getVehicleTypes() {
    return function(dispatch) {
        dispatch({type: GET_VEHICLE_TYPE})
        return driverServerInstance.get(`/masterdata/vehicle/types`)
        .then(({data}) => {
            dispatch({
                type: GET_VEHICLE_TYPE_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_VEHICLE_TYPE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getDeliveryAreas(provinceCode) {
    return function(dispatch) {
        dispatch({type: GET_DELIVERY_AREAS})
        return driverServerInstance.get(`/masterdata/deliveryareas/${provinceCode}`)
        .then(({data}) => {
            dispatch({
                type: GET_DELIVERY_AREAS_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_DELIVERY_AREAS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getIndividualDocument(id) {
    return function(dispatch) {
        dispatch({type: GET_INDIVIDUAL_DOCUMENT})
        return driverServerInstance.get(`/application/documents/individual/${id}`)
        .then(({data}) => {
            dispatch({
                type: GET_INDIVIDUAL_DOCUMENT_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_INDIVIDUAL_DOCUMENT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getDriverById(driverId) {
    return function(dispatch) {
        dispatch({type: GET_DRIVER_BY_ID})
        return adminServerInstance.get(`/map/getdriverbyid?driver_id=${driverId}`)
        .then(({data}) => {
            dispatch({
                type: GET_DRIVER_BY_ID_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type:  GET_DRIVER_BY_ID_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function editProfile(id, params) {
    return function(dispatch) {
        dispatch({type: EDIT_PROFILE})
        return deliveryServerInstance.put(`/application/profile/individual/${id}`, {...params})
        .then(({data}) => {
            dispatch({
                type: EDIT_PROFILE_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: EDIT_PROFILE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getCityList(id) {
    return function(dispatch) {
        dispatch({type: GET_CITY_LIST})
        return driverServerInstance.get(`/masterdata/cities/${id}`)
        .then(({data}) => {
            dispatch({
                type: GET_CITY_LIST_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_CITY_LIST_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getReviewCount(id) {
    return function(dispatch) {
        dispatch({type: GET_REVIEW_COUNT})
        return driverServerInstance.get(`/application/count?criteria=tobereviewed&warehouse=${id}`)
        .then(({data}) => {
            dispatch({
                type: GET_REVIEW_COUNT_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: GET_REVIEW_COUNT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function putReviewResult(id, params) {
    return function(dispatch) {
        dispatch({type: PUT_REVIEW_RESULT})
        return driverServerInstance.put(`/application/audit/individual/${id}`, {...params})
        .then(({data}) => {
            dispatch({
                type: PUT_REVIEW_RESULT_SUCCESS,
                payload: data.biz_data
            })
            return Promise.resolve(data.biz_data);
        }).catch(error => {
            dispatch({
                type: PUT_REVIEW_RESULT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function resetDriverPassword(phone, password, operator, warehouse) {
    return function (dispatch) {
        dispatch({type: RESET_DRIVER_PASSWORD})
        return deliveryServerInstance.put(`/account/password/individual/${phone}`, {
            new_password: password,
            operator: operator,
            warehouse: warehouse
        }).then(({data}) => {
            dispatch({
                type: RESET_DRIVER_PASSWORD_SUCCESS,
                payload: data
            })
            return Promise.resolve(Object(data));
        }).catch(error => {
            dispatch({
                type: RESET_DRIVER_PASSWORD_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

